/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_PdfInputs */

const en_mobile_upload_pdf = /** @type {(inputs: Mobile_Upload_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a PDF`)
};

const es_mobile_upload_pdf = /** @type {(inputs: Mobile_Upload_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir un PDF`)
};

/**
* | output |
* | --- |
* | "Upload a PDF" |
*
* @param {Mobile_Upload_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_pdf = /** @type {((inputs?: Mobile_Upload_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_pdf(inputs)
	return en_mobile_upload_pdf(inputs)
});